import { useTranslation } from "react-i18next";
import { ReactEventHandler } from "react";
import ProfileLoader from "../../../../../../../components/ABOProfile/ProfileLoader/ProfileLoader";
import Order from "../../../../../../Customers/OrderHistory/OrderHistoryTable/OrdersByPeriod/Order/Order";
import defaultContent from "../../../../../../../content/profile";
import { OrderResponse } from "../../../../../../../services/Customer/CustomerOrderList/customerOrderListAPI.types";
import { useAppSelector } from "../../../../../../../store";

type Props = {
  viewAllOnClick: ReactEventHandler;
  order?: OrderResponse;
  isFetching: boolean;
};

const RecentOrderListView = (props: Props) => {
  const { t } = useTranslation(["profile"]);
  const { viewAllOnClick, order, isFetching } = props;
  const showCSIInfo = useAppSelector((state) => state.profileOrders.showCSIInfo);

  if (isFetching === false && order) {
    const { CustomerOrderList } = order;

    return (
      <>
        {CustomerOrderList?.length > 0 && (
          <>
            <div className="overview-tab__order-header">
              <div className="overview-tab__recent-order">
                {`${t(
                  "customerProfile.overviewTab.mostRecentOrder",
                  defaultContent["customerProfile"]["overviewTab"]["mostRecentOrder"],
                )}`}
              </div>
              <div
                className="overview-tab__view-all"
                onClick={viewAllOnClick}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    viewAllOnClick(e);
                  }
                }}
                role="button"
                tabIndex={0}
              >
                {`${t(
                  "customerProfile.overviewTab.viewAll",
                  defaultContent["customerProfile"]["overviewTab"]["viewAll"],
                )}`}
              </div>
            </div>
            {CustomerOrderList.map((order, index) => (
              <Order
                order={order}
                isCompact={true}
                key={order.OrderNumber}
                orderIndex={index}
                showVCSOrderTag={showCSIInfo}
              />
            ))}
          </>
        )}
      </>
    );
  }
  return <ProfileLoader row={1} card={true} isFetching={isFetching} />;
};

export default RecentOrderListView;
